import axios from 'axios';
const API_URL = import.meta.env.VITE_NEXT_PUBLIC_API_URL;

console.log(API_URL);

const api = axios.create({
  baseURL: `${API_URL || 'http://localhost:3001'}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Let the AuthContext handle 401 errors instead of redirecting here
    // This prevents race conditions and allows proper error handling
    return Promise.reject(error);
  }
);

export default api; 